import { Tag, TagPropsStrict } from '@servicetitan/design-system';
import { FC } from 'react';
import { AgreementStatus } from '../../../api/portal-dashboard.api';

const statuses: Record<AgreementStatus, [TagPropsStrict['color'], boolean, string]> = {
    [AgreementStatus.Activated]: ['#007A4D', true, 'Active'],
    [AgreementStatus.Sent]: ['#FFECCC', false, 'Ready to Sign'],
    [AgreementStatus.Draft]: ['info', false, 'Ready to Sign'],
    [AgreementStatus.Rejected]: ['critical', true, 'Rejected'],
    [AgreementStatus.Accepted]: ['success', true, 'Accepted'],
    [AgreementStatus.Canceled]: ['critical', true, 'Canceled'],
    [AgreementStatus.Expired]: ['warning', true, 'Expired'],
    [AgreementStatus.Hold]: ['warning', true, 'On Hold'],
    [AgreementStatus.AutoRenew]: ['success', true, 'Auto Renew'],
};

export const ServiceAgreementStatusTag: FC<{ status: AgreementStatus }> = ({ status }) => {
    const data = statuses[status];
    return data ? (
        <Tag color={data[0]} subtle={data[1]}>
            {data[2]}
        </Tag>
    ) : null;
};
